import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Excel Icon Cell Renderer
 * Displays Excel download icon
 */
@Component({
  selector: 'app-excel-icon-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  template: `
    <mat-icon
      color="primary"
      svgIcon="excel"
      (click)="onDownloadClick()"
      matTooltip="Descargar Reporte"
      class="pointer-icon"
      style="cursor: pointer;">
    </mat-icon>
  `,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    .pointer-icon {
      cursor: pointer;
    }
  `]
})
export class ExcelIconCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  onDownloadClick(): void {
    if (this.params?.onDownloadClick) {
      this.params.onDownloadClick(this.params.data);
    }
  }
}
